import Text from '../Texts';

export interface IdentityField {
    name: string;
    label: string;
    placeholder: string;
    /** Digits typed on a Persian keyboard are rewritten as Latin on change. */
    numeric?: boolean;
}

export const personalFields: IdentityField[] = [
    {
        name: 'name',
        label: Text.PersonalIdentty.fullname,
        placeholder: Text.PersonalIdentty.fullname,
    },
    {
        name: 'display_name',
        label: Text.PersonalIdentty.developerName,
        placeholder: Text.PersonalIdentty.developerName,
    },
    {
        name: 'national_id',
        label: Text.PersonalIdentty.nationalCode,
        placeholder: Text.PersonalIdentty.nationalCode,
        numeric: true,
    },
    { name: 'address', label: Text.PersonalIdentty.address,
        placeholder:Text.PersonalIdentty.address,
     },
     {
        name: 'postal_code',
        label: Text.PersonalIdentty.postallCode,
        placeholder: Text.PersonalIdentty.postallCode,
        numeric: true,
    },

    {
        name: 'phone',
        label: Text.PersonalIdentty.phone,
        placeholder: Text.PersonalIdentty.phone,
        numeric: true,
    },
   
   
    
   
];

export const legalFields: IdentityField[] = [
    {
        name:  'name',
        label: Text.legalIdentty.company,
        placeholder: Text.legalIdentty.company,
    },
    {
        // Had a leading space, so this posted as " display_name" and the api
        // never saw the value.
        name: 'display_name',
        label: Text.legalIdentty.developerName,
        placeholder: Text.legalIdentty.developerName,
    },
    {
        name: 'national_id',
        label: Text.legalIdentty.nationalCode,
        placeholder: Text.legalIdentty.nationalCode,
        numeric: true,
    },
    { name: 'address', label: Text.legalIdentty.address,
        placeholder:Text.legalIdentty.address 
    },
    {
        // Was 'postCode', which the api does not accept: it validates
        // `postal_code` as required, so the legal edit form always came back
        // with "وارد کردن کد پستی الزامی است" no matter what was typed.
        name: 'postal_code',
        label: Text.legalIdentty.postallCode,
        placeholder: Text.legalIdentty.postallCode,
        numeric: true,
    },
    {
        name: 'phone',
        label: Text.legalIdentty.phone,
        placeholder: Text.legalIdentty.phone,
        numeric: true,
    },
   
    
   
  
];